import { Tag } from '@cian/components';
import * as React from 'react';

import { ELandStatusType } from '../../../../json_query';
import { ILandStatusTypesTag } from '../../../state/tags/definitions/land_status';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ILandStatusTypesTagItemProps {
  tag: ILandStatusTypesTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const landStatusTypeMap = {
  [ELandStatusType.Farm]: 'Фермерское хозяйство',
  [ELandStatusType.PrivateFarm]: 'Личное подсобное хозяйство',
  [ELandStatusType.Gardening]: 'Садоводство',
  [ELandStatusType.IndustrialLand]: 'Земля промназначения',
  [ELandStatusType.InvestmentProject]: 'Инвестпроект',
  [ELandStatusType.IndividualHousingConstruction]: 'ИЖС',
  [ELandStatusType.CountryhouseNonCommercialPartnership]: 'ДНП',
};

export const LandStatusTypesTagItem = ({ onDeleteClick, tag, withNewTag }: ILandStatusTypesTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {landStatusTypeMap[tag.value]}
    </TagComponent>
  );
};
